export default __webpack_public_path__ + "static/bahrain-2f8e5b021a9ad818df3994918d9af8ed.svg";